module.exports = __webpack_public_path__ + "img/icon-button.5899c183.png";